var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMkr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_384_12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "white",
    fillOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.1248 20.8V13.2693L13.8357 17.5675V20.8H15.2933V17.264C15.2931 17.1326 15.2624 17.0031 15.2036 16.8855C15.1448 16.768 15.0596 16.6657 14.9547 16.5867L8.0288 11.3723C7.90213 11.2782 7.75184 11.2211 7.59465 11.2073C7.43745 11.1934 7.27951 11.2235 7.13837 11.2941C6.99723 11.3646 6.87843 11.473 6.79516 11.607C6.71188 11.741 6.66741 11.8955 6.66667 12.0533V20.8H8.1248ZM23.9189 20.8V13.2693L18.208 17.5675V20.8H16.7504V17.264C16.7507 17.1326 16.7814 17.0031 16.8402 16.8855C16.8989 16.768 16.9841 16.6657 17.0891 16.5867L24.0149 11.3744C24.1415 11.2804 24.2916 11.2233 24.4486 11.2094C24.6056 11.1955 24.7634 11.2254 24.9044 11.2957C25.0455 11.366 25.1643 11.474 25.2478 11.6078C25.3312 11.7415 25.3759 11.8957 25.3771 12.0533V20.8H23.9189Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_384_12"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMkr);
export default __webpack_public_path__ + "static/media/MKR.9783ca0efb7c54001274b7a5f336503a.svg";
export { ForwardRef as ReactComponent };